import { render, staticRenderFns } from "./FarmacieViewComponent.vue?vue&type=template&id=4eaa671a"
import script from "./FarmacieViewComponent.vue?vue&type=script&lang=js"
export * from "./FarmacieViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports